export const messages = [
  {
    _warningDescription: 'warning selection passengers',
    en_US: {
      title: 'careful',
      message: 'You must select a passenger',
    },
    es_MX: {
      title: 'Cuidado',
      message: 'Debe seleccionar un pasajero',
    },
    ja_JP: {
      title: '注意深い',
      message: '乗客を選択する必要があります.',
    },
    kr_KR: {
      title: '주의 깊은',
      message: '승객을 선택해야 합니다.',
    },
    zh_CN: {
      title: '小心',
      message: '您必須選擇一名乘客',
    },
    du_NL: {
      title: 'voorzichtig',
      message: 'U moet een passagier selecteren',
    },
    pt_PT: {
      title: 'cuidadoso',
      message: 'Você deve selecionar um passageiro',
    },
    fr_FR: {
      title: 'prudent',
      message: 'Vous devez sélectionner un passager',
    },
  },
];
